module.exports = __webpack_public_path__ + "static/media/trust-5.13868c95.png";